<template>
  <z-form ref="form" @submit.prevent.native="isNumber">
    <z-form-group class="row">
      <div class="col-12">
        <z-form-input
          :rules="{ required: true, pbx_internal_number: true, min: 1, max: 5 }"
          mode="blur"
        >
          <i-input
            v-model="form.number"
            class="ivu-input-number--no-controls w-100"
            :clearable="true"
            :min="1"
            :max="5"
            @keypress.native="isNumber($event)"
          />
        </z-form-input>
      </div>
    </z-form-group>
  </z-form>
</template>

<script>
  import { NumberService } from '@pbx/services/NumberService';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        form: { number: null }
      };
    },

    computed: {
      ...mapGetters('core/auth', ['user'])
    },

    methods: {
      isNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      validate() {
        return this.$refs.form.validate();
      },

      send() {
        return NumberService.createInternal(String(this.form.number), this.user.id);
      }
    }
  };
</script>
